/* VISTA Resumen de Caja para /caja-resumen
Muestra un resumen de las ventas realizadas presencialmente,
Total de tickets vendidos, cuanto efectivo debe tener, cuanto por qr, que tickets tiene disponibles para seguir vendiendo*/
import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import Loading from '../../components/Loading';
import { Close, InfoOutlined, ArrowBack } from '@mui/icons-material';
import { IconButton, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, Alert, TextField, Select, MenuItem, DialogActions, Tooltip, Divider } from '@mui/material';
import { toast } from "react-toastify";
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { parseISO, format } from "date-fns";
import { es } from "date-fns/locale";
import useEventoStore from '../../stores/useEventoStore';

const ResumenCaja = () => {
  const [loading, setLoading] = useState(true);
  const [resumen, setResumen] = useState(null);
  const [modalRendicion, setModalRendicion] = useState(false);
  const [loadingRendicion, setLoadingRendicion] = useState(false);
  const [montoEfectivo, setMontoEfectivo] = useState("");
  const [talon, setTalon] = useState("");
  const [ticketsDevueltos, setTicketsDevueltos] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [fechaTarifas, setFechaTarifas] = useState(null);

  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null,
  });

  const param = useParams();
  const [setEventoData] = useState(null);

  const location = useLocation();
  const history = useHistory();

  const cargarResumen = async () => {
    setLoading(true);
    try {
      const response = await api.rendiciones.generarResumenVendedor(param.id);
      if (response.status === "success") {
        setResumen(response.data);
        setFechaTarifas(response.data.fecha_tarifa);
      } else {
        toast.error("Error al cargar resumen");
      }
    } catch (error) {
      toast.error("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarResumen();
  }, [param.id]);

  const enviarRendicion = async () => {
    setLoadingRendicion(true);
    try {
      const data = {
        monto_efectivo: montoEfectivo === "" ? 0 : parseFloat(montoEfectivo),
        talon: talon || undefined,
        tickets_devueltos: ticketsDevueltos ? parseInt(ticketsDevueltos) : undefined,
        observaciones
      };

      const response = await api.rendiciones.enviarRendicion(param.id, data);
      if (response.status === "success") {
        toast.success("Rendición enviada correctamente");
        setModalRendicion(false);
        resetForm();
        cargarResumen();
      } else {
        toast.error(response.message || "Error al enviar rendición");
      }
    } catch (error) {
      toast.error("Error de conexión");
    } finally {
      setLoadingRendicion(false);
    }
  };

  const resetForm = () => {
    setMontoEfectivo("");
    setTalon("");
    setTicketsDevueltos("");
    setObservaciones("");
  };

  useEffect(() => {

    const callApi = async () => {
      try {
        setLoading(true);
        const data = await useEventoStore.getState().fetchEvento(param.id);
        if (data) {
          setEventoData(data.evento);
        } else {
          setState(prevState => ({
            ...prevState,
            error: data.message || "Error al cargar el evento.",
          }));
        }
      } catch (error) {
        setState({
          ...state,
          error: "Error en la Red.",
        });
      } finally {
        setLoading(false);
      }
    };
    callApi();
  }, [param.id]);

  const handleGoBack = () => {
    if (location.pathname.split('/').length > 4) {
      const basePath = location.pathname.split('/').slice(0, 4).join('/');
      history.push(basePath);
    } else {
      history.push(`/eventos`);
    }
  }

  if (loading && !resumen) return <Loading />;


  return (
    <div container spacing={3} style={{ mb: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div className="d-flex flex-row align-items-center justify-content-between mb-3 w-100">
        <Tooltip title="Volver">
          <IconButton
            onClick={handleGoBack}
            size="small"
            sx={{
              color: "#0b0062",
              border: "none",
              borderRadius: "4px",
              padding: "4px 12px",
              "&:hover": {
                backgroundColor: "#5656ff"
              }
            }}
          >
            <ArrowBack fontSize="small" />
            <span style={{
              marginLeft: "4px",
              fontSize: "16px",
              fontFamily: "Bricolage Grotesque, serif"
            }}>
              Volver
            </span>
          </IconButton>
        </Tooltip>

        <p style={{
          color: '#0b0062',
          fontSize: '16px',
          margin: '8px 0 0 0'
        }}>
          {fechaTarifas
            ? format(parseISO(fechaTarifas), "cccc d", { locale: es })
            : format(new Date(), "cccc d", { locale: es })}
        </p>
      </div>
      <div style={{ backgroundColor: "#E7EBFF", borderRadius: "10px", width: "90%", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="d-flex flex-column align-items-center">
          <Typography variant="p" sx={{ fontSize: "26px", fontWeight: "500", color: "#3751D0", mb: 1 }}>Saldo en efectivo</Typography>
          <Typography variant="p" sx={{ fontSize: "40px", fontWeight: "400", color: "#0b0062", mb: 1 }}>${resumen?.resumen?.saldo_efectivo?.toLocaleString('es-AR') || 0}</Typography>
        </div>
        <Divider variant="middle" sx={{ backgroundColor: "#3751D0", width: "90%" }} />
        <div className="d-flex flex-column align-items-center mt-3 mb-2" style={{ width: "90%" }}>
          <div className="d-flex flex-row align-items-center justify-content-between  w-100">
            <Typography variant="p" sx={{ fontSize: "18px", fontWeight: "700", color: "#0b0062", mb: 1 }}>Saldo en QR: </Typography>
            <Typography variant="p" sx={{ fontSize: "18px", fontWeight: "400", color: "#0b0062", mb: 1 }}>${resumen?.resumen?.saldo_qr?.toLocaleString('es-AR') || 0} </Typography>
          </div>
          <div className="d-flex flex-row align-items-center mb-1 justify-content-between  w-100">
            <Typography variant="p" sx={{ fontSize: "18px", fontWeight: "700", color: "#0b0062", mb: 1 }}>Total recaudado: </Typography>
            <Typography variant="p" sx={{ fontSize: "18px", fontWeight: "400", color: "#0b0062", mb: 1 }}>${resumen?.resumen?.monto_total?.toLocaleString('es-AR') || 0} </Typography>
          </div>
        </div>
      </div>

      <Typography variant="p" sx={{ textAlign: "center", fontSize: "26px", fontWeight: "500", color: "#3751D0", my: 2 }}>Tickets vendidos: <span style={{ color: "#0b0062" }}>{resumen?.entradas_vendidas || 0} </span></Typography>
      <div style={{
        backgroundColor: "#F6F7FF",
        borderRadius: "10px",
        width: "90%",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <Typography variant="p" sx={{ fontSize: "26px", fontWeight: "500", color: "#3751D0", mb: 3 }}>
          Tickets disponibles
        </Typography>
        {resumen?.tarifas?.filter(tarifa => tarifa.disponible > 0).length > 0 ? (
          resumen.tarifas
            .filter(tarifa => tarifa.disponible > 0)
            .map((tarifa) => {
              let colorObj = {};
              try {
                colorObj = JSON.parse(tarifa.color);
              } catch { colorObj = { r: 0, g: 0, b: 0, a: 1 }; }
              const color = `rgba(${colorObj.r},${colorObj.g},${colorObj.b},${colorObj.a})`;
              return (
                <div
                  key={tarifa.idtarifavoucher}
                  style={{ display: "flex", alignItems: "center", width: "100%", marginBottom: 10, borderBottom: "0.25px solid #e0e0e0", paddingBottom: 8, gap: 8 }}>
                  <span style={{
                    display: "inline-block", width: 34, height: 14, borderRadius: 6, background: color, marginRight: 8
                  }} />
                  <span style={{ fontSize: "20px", fontWeight: 700, color: "#0b0062" }}>{tarifa.concepto}:</span>
                  <span style={{ fontSize: "20px", fontWeight: 700, color: "#0b0062", marginLeft: 4 }}>{tarifa.disponible}</span>
                  {tarifa.disponible <= 10 && (
                    <Tooltip title="¡Quedan pocos tickets disponibles!" arrow>
                      <InfoOutlined sx={{ color: "#ff1744", fontSize: 18, marginLeft: 4 }} />
                    </Tooltip>
                  )}
                </div>
              );
            })
        ) : (
          <Typography variant="body2">No tienes tarifas asignadas</Typography>
        )}
      </div>

      <div className="d-flex flex-column align-items-center text-center w-100 mt-4 gap-4">
        <Button
          variant="contained"
          sx={{
            fontSize: "18px !important",
            width: "80%",
            backgroundColor: 'white',
            color: '#0b0062',
            border: '1px solid #0b0062',
            borderRadius: '8px',
          }}
          onClick={() => setModalRendicion(true)}
          disabled={resumen?.tiene_pendiente}
        >
          {resumen?.tiene_pendiente ? "Rendición Pendiente" : "Rendición"}
        </Button>

        <Button
          variant="contained"
          sx={{
            fontSize: "18px !important",
            width: "80%",
            backgroundColor: 'white',
            color: '#0b0062',
            border: '1px solid #0b0062',
            borderRadius: '8px',
          }}
          onClick={() => history.push(`/eventos/${param.id}/venta-presencial`)}
        >
          Vender
        </Button>

        <Button
          variant="contained"
          sx={{
            fontSize: "18px !important",
            width: "80%",
            backgroundColor: 'white',
            color: '#0b0062',
            border: '1px solid #0b0062',
            borderRadius: '8px',
          }}
          onClick={() => history.push(`/eventos/${param.id}/caja-stock`)}
        >
          Asignación
        </Button>
      </div>

      {/* Modal de Rendición */}
      <Dialog
        open={modalRendicion}
        onClose={(e, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setModalRendicion(false);
          }
        }}
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontSize: "18px", color: "#0b0062", fontWeight: "700", padding: "12px" }}>Rendición</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setModalRendicion(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent sx={{ paddingTop: "0", padding: "12px" }}>
          <Alert severity="info" sx={{ mb: 2, mt: 1 }}>
            Indica el monto a rendir y, si corresponde, el talonario a devolver.
          </Alert>

          <Typography sx={{ mt: 2, fontSize: "14px", color: "grey" }}>
            Efectivo a rendir <span>(${resumen?.resumen?.saldo_efectivo?.toLocaleString('es-AR') || 0})</span>
          </Typography>
          <TextField
            type="number"
            value={montoEfectivo}
            placeholder="0"
            onChange={e => setMontoEfectivo(e.target.value.replace(/^0+(?=\d)/, ""))}
            fullWidth
            InputLabelProps={{
              sx: {
                fontSize: "14px",
                fontFamily: "Bricolage Grotesque",
              }
            }}
            sx={{
              fontFamily: "Bricolage Grotesque",
              mt: 1,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& .MuiInputBase-input': {
                fontFamily: "Bricolage Grotesque",
                fontSize: "15px",
                height: "40px",
                boxSizing: "borderBox",
                padding: "8px 12px",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
          />

          <Typography sx={{ mt: 2, fontSize: "14px", color: "grey" }}>
            Devolucion de talonario
          </Typography>
          <Select
            value={talon}
            onChange={e => setTalon(e.target.value)}
            fullWidth
            displayEmpty
            sx={{
              backgroundColor: "#ffff",
              '& .MuiSelect-select': {
                padding: "8px 14px",
                display: 'flex',
                alignItems: 'center',
                height: "24px",
              }
            }}
          >
            <MenuItem value="">Sin devolución</MenuItem>
            {resumen?.talonarios?.map(t => (
              <MenuItem key={t.talonario} value={t.talonario}>
                Talonario #{t.talonario}{/*  ({t.disponibles} disponibles) */}
              </MenuItem>
            ))}
          </Select>

          {talon && (
            <>
              <Typography sx={{ mt: 2, fontSize: "14px", color: "grey" }}>
                Cantidad de tickets a devolver
              </Typography>
              <TextField
                /* label={`Cantidad de tickets a devolver (máx: ${resumen?.talonarios?.find(t => t.talonario === talon)?.disponibles || 0
                  })`} */
                type="number"
                value={ticketsDevueltos}
                onChange={e => setTicketsDevueltos(e.target.value)}
                fullWidth
                InputLabelProps={{
                  sx: {
                    fontSize: "14px",
                    fontFamily: "Bricolage Grotesque",
                  }
                }}
                sx={{
                  fontFamily: "Bricolage Grotesque",
                  mt: 1,
                  '& .MuiInputBase-input-MuiOutlinedInput-input': {
                    fontFamily: "Bricolage Grotesque",
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: "Bricolage Grotesque",
                    fontSize: "15px",
                    height: "40px",
                    boxSizing: "borderBox",
                    padding: "8px 12px",
                  },
                  '& label.Mui-focused': {
                    color: '#5656FF',
                    fontFamily: "Bricolage Grotesque"
                  },
                  '& .MuiOutlinedInput-root': {
                    height: "40px",
                    '& fieldset': {
                      borderColor: '#B2BAC2',
                    },
                    '&:hover fieldset': {
                      borderColor: '#5656ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#5656ff',
                    },
                  }
                }}
              />
            </>
          )}

          <Typography sx={{ mt: 2, fontSize: "14px", color: "grey" }}>
            Observaciones
          </Typography>
          <TextField
            multiline
            rows={2}
            value={observaciones}
            onChange={e => setObservaciones(e.target.value)}
            fullWidth
            InputLabelProps={{
              sx: {
                fontSize: "14px",
                fontFamily: "Bricolage Grotesque",
              }
            }}
            sx={{
              fontFamily: "Bricolage Grotesque",
              mt: 1,
              '& .MuiInputBase-input-MuiOutlinedInput-input': {
                fontFamily: "Bricolage Grotesque",
              },
              '& .MuiInputBase-input': {
                fontFamily: "Bricolage Grotesque",
                fontSize: "15px",
                height: "40px",
                boxSizing: "borderBox",
                padding: "8px 12px",
              },
              '& label.Mui-focused': {
                color: '#5656FF',
                fontFamily: "Bricolage Grotesque"
              },
              '& .MuiOutlinedInput-root': {
                height: "40px",
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#5656FF",
              color: "white",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: window.innerWidth <= 576 ? "12px" : "14px",
              width: "100%"
            }}
            onClick={enviarRendicion}
            disabled={loadingRendicion}
          >
            {loadingRendicion ? <CircularProgress size={24} /> : "Enviar Rendición"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ResumenCaja;